import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { ProgramsBlock } from 'shared/components/ProgramsBlock';
import { useFillApplicationButtonClick } from 'shared/containers/stickyButtons/FillApplicationButton/hooks/useFillApplicationButtonClick';
import { selectProgramsSummary } from 'shared/selectors/dictionaries/selectProgramsSummary';
import { mapProgramsSummaryToProgramCards } from 'shared/utils/programs/mapProgramsSummaryToProgramCards';

export const ProgramsBlockContainer = () => {
  const programsSummary = useSelector(selectProgramsSummary);
  const programs = useMemo(() => mapProgramsSummaryToProgramCards(programsSummary), [programsSummary]);
  const { handleClick, isPending } = useFillApplicationButtonClick();

  if (programs.length === 0) {
    return null;
  }

  return <ProgramsBlock programs={programs} onCtaClick={handleClick} isCtaLoading={isPending} />;
};
